import http from '@services/http';

export const getGroupBlacklistedCompanies = data => {
  return http.get(`/groups/${data.groupId}/company-blacklist`);
};

export const updateGroupCompanyBlacklist = data => {
  return http.post(`/groups/${data.groupId}/company-blacklist`, data);
};